import ProductListValues from './productlistvalues.js';

export const prodListValues = new ProductListValues(
    document.getElementById('ItemsPerPage').value,
    document.getElementById('isUserRegistered').value
);